import React from "react";
import "./subFooter.css";

const SubFooter = () => {
  return (
    <div className="app__subfooter">
      <div className="app__subfooter-right">
        <p className="app__subfooter-right-p">
          Designed and built by{" "}
          <span className="gradient__text">Paul Boluwatife</span>
        </p>
      </div>
    </div>
  );
};

export default SubFooter;
